import { render } from "./FeeBurn.vue?vue&type=template&id=6ec9f54c&scoped=true"
import script from "./FeeBurn.vue?vue&type=script&lang=js"
export * from "./FeeBurn.vue?vue&type=script&lang=js"

import "./FeeBurn.vue?vue&type=style&index=0&id=6ec9f54c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec9f54c"],['__file',"resources/js/components/FeeBurn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ec9f54c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ec9f54c', __exports__)) {
    api.reload('6ec9f54c', __exports__)
  }
  
  module.hot.accept("./FeeBurn.vue?vue&type=template&id=6ec9f54c&scoped=true", () => {
    api.rerender('6ec9f54c', render)
  })

}


export default __exports__